import { render } from "./LiftTabs.vue?vue&type=template&id=8f8caa1a&scoped=true"
import script from "./LiftTabs.vue?vue&type=script&lang=js"
export * from "./LiftTabs.vue?vue&type=script&lang=js"

import "./LiftTabs.vue?vue&type=style&index=0&id=8f8caa1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8caa1a"]])

export default __exports__